import { useState } from "react";
import Lastmenu from "./LastMenu";
import bot from '../../assets/images/happy.png';
import you from '../../assets/images/boy.png';
import MetalCollection from "./MetalCollection";

const Catelog = () =>{
    const [time] = useState(new Date());

    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    return(
        <>
            <div className="frame1 animated-frame" style={{textAlign: 'center'}}>
                <center><h2>Catelog</h2></center>
                <a href="https://agromech.com/collections/all-products" target="_blank" rel="noopener noreferrer">
                    <button className="detatils-button2" onClick={() => {
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        }}>All Products</button>
                </a><br></br>
                <button className="detatils-button2" onClick={() => {
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        }}>Metal Collection</button><br></br>
                <a href="https://agromech.com/collections/school-collection" target="_blank" rel="noopener noreferrer">
                    <button className="detatils-button2" onClick={() => {
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        }}>School Collection</button>
                </a>
            </div>
            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">All Products</div>
                </div>
                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
                    <Lastmenu />
                </>
            )}
            {showFrame2 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Metal Collection</div>
                </div>
                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
                    <MetalCollection />
                </>
            )}
            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">School Collection</div>
                </div>
                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
                    <Lastmenu />
                </>
            )}
        </>
    );
}
export default Catelog;